import gql from 'graphql-tag';
import {type ChildDataProps, graphql} from 'react-apollo';

import {type User} from '../types/graphql';

// This query returns the currently-logged-in User.
export const GET_VIEWER_QUERY = gql`
  query Viewer($includeStorage: Boolean = false) {
    viewer {
      id
      analyticsId
      admin
      email
      entity
      defaultFramework
      photoUrl
      flags
      code
      username
      createdAt
      name
      accountType
      userInfo
      hideTeamsFromPublic
      limits
      nvidiaAccountLinkedAt
      signupRequired
      personalEntityDisabled
      isNvidiaAccountLinked
      instanceAdminTeamAccessDisabled
      teams(first: 100) {
        edges {
          node {
            id
            name
            photoUrl
            defaultAccess
            readOnlyAdmin
            privateOnly
            isTeam
            organizationId
          }
        }
      }
      organizations {
        id
        name
        orgType
        subscriptions {
          id
          subscriptionType
        }
      }
      defaultEntity {
        id
        name
      }
      userEntity {
        id
        name
        defaultAccess
        codeSavingEnabled
        storageBytes @include(if: $includeStorage)
        settings {
          defaultCloudRegion {
            id
            provider
            region
          }
        }
        isTeam
        defaultAlerts {
          id
          condition {
            __typename
            ... on FinishedRunCondition {
              success
            }
            ... on StoppedRunCondition {
              minimumRunDuration
            }
          }
          subscriptions {
            __typename
            ... on EmailSubscription {
              id
            }
            ... on SlackChannelSubscription {
              id
            }
          }
        }
        integrations {
          edges {
            node {
              id
              __typename
              ... on SlackIntegration {
                teamName
                channelName
              }
            }
          }
        }
        claimedEntities {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const GET_VIEWER_PHOTO_URL_QUERY = gql`
  query ViewerPhotoURL {
    viewer {
      id
      photoUrl
    }
  }
`;

export const VIEWER_FEATURE_FLAGS = gql`
  query viewerFeatureFlags($rampIDType: RampIDType!) {
    viewer {
      id
      featureFlags(rampIDType: $rampIDType) {
        rampKey
        isEnabled
      }
    }
  }
`;

export interface GetViewerQueryResponse {
  viewerLoading: boolean;
  viewer: User;
  refetch: () => void;
}

// Wrap a component with this to access the currently-logged-in user as this.props.viewer
export const withViewer = graphql<
  any,
  GetViewerQueryResponse,
  {},
  ChildDataProps<any, GetViewerQueryResponse, {}>
>(GET_VIEWER_QUERY, {
  options: props => ({
    variables: {
      includeStorage: props.match?.path === '/settings', // Include total storage with viewer on settings page
    },
  }),
  props: ({data}) => {
    return {
      viewer: data && data.viewer,
      viewerLoading: data && data.loading,
      refetch: data && data.refetch,
      // viewerError: data && data.error,
    };
  },
});
